import AnnotatedSelectPicker from './AnnotatedSelectPicker';

export default AnnotatedSelectPicker;
